export default "__VITE_PUBLIC_ASSET__609680f6__"